export default __webpack_public_path__ + "static/media/KX-TG6811GB_HSF_gallery_global_04.5f302715.jpg";